import { useContext } from 'react'
import { FeatureFlagsContext } from 'src/contexts/FeatureFlagsContext'

export const useFeatureFlags = () => useContext(FeatureFlagsContext)
